



























































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import KYCForm from '@company-common/model/kyc-form/KYCForm'

import AppRadioSelection from '@core/components/AppRadioSelection.vue'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import TrustedIndividual from '@master/model/kyc-form/TrustedIndividual'
import ClientDeclarationData from '@company-common/model/kyc-form/ClientDeclaration'
import AppTooltip from '@core/components/AppTooltip.vue'
import { inject } from 'inversify-props'
import { IProjectInfo } from '@master/config/IProjectInfo'

const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    AppRadioSelection,
    AppForm,
    AppTooltip
  }
})
export default class ClientDeclaration extends Vue {
  @kycFormStore.State
  private kycForm!: KYCForm;

  @inject()
  private projectInfo: IProjectInfo;

  private boNote = 'A Beneficial Owner is defined as the natural person(s) who' +
               ' ultimately owns or controls a customer and/or the person on whose behalf a' +
                'transaction is being conducted and includes the person who exercises ultimate' +
               ' effective control over body corporate or unincorporated. "Ultimately effective' +
                'control" refers to situations in which ownership/control is exercised through a' +
                'chain of ownership or by means of control other than direct control.'

  private pepNote = 'Politically Exposed Person means a domestic politically exposed person, foreign politically exposed person or' +
                                  ' international organization politically exposed person.'

  private boTooltip = `<div style="width:400px; text-align:justify">${this.boNote}</div>`
  private pepTooltip = `<div style="width:400px; text-align:justify">${this.pepNote}</div>`

  get clientDeclaration () {
    return this.kycForm.clientDeclaration
  }

  // @TODO: Handle client 1 and 2 beneficial declaration
  get client1BeneficialOwner () {
    return this.kycForm.client1.beneficialOwner
  }

  get client2BeneficialOwner () {
    return this.kycForm.client2.beneficialOwner
  }

  get isClient2Included () {
    return this.kycForm.client2.personalDetails.included
  }

  get trustedIndividual () {
    return this.kycForm.trustedIndividual
  }

  get clientDeclarationStructure (): FormStructure<ClientDeclarationData> {
    return [
      {
        label: 'Name of Introducer',
        key: 'clientDeclIntroducedName',
        classes: ['colspan'],
        disabled: (clientDeclaration) => clientDeclaration.clientDeclIntroduced !== 'yes'
      },
      {
        label: 'NRIC/FIN/Passport No.',
        key: 'clientDeclIntroducedId',
        classes: ['colspan'],
        disabled: (clientDeclaration) => clientDeclaration.clientDeclIntroduced !== 'yes'
      }
    ]
  }

  get trustedIndividualStructure (): FormStructure<TrustedIndividual> {
    return [
      {
        label: 'Name of Trusted Individual',
        key: 'name',
        disabled: true
      }, {
        label: 'NRIC/FIN/Passport No.',
        key: 'nric',
        disabled: true
      }, {
        label: 'Relationship to Client(s)',
        key: 'relationship',
        disabled: true
      }, {
        label: 'Contact Number',
        key: 'contact',
        disabled: true
      }
    ]
  }

  @Watch('clientDeclaration.clientDeclIntroduced')
  clearNameAndId () {
    if (this.clientDeclaration.clientDeclIntroduced === 'na') {
      this.clientDeclaration.clientDeclIntroducedName = ''
      this.clientDeclaration.clientDeclIntroducedId = ''
    }
  }

  @Watch('trustedIndividual.confirmLanguage')
  changeLanguage () {
    if (this.trustedIndividual.confirmLanguage !== 'others') {
      this.trustedIndividual.confirmLanguageOthers = ''
    }
  }
}
